import { useState } from "react";
import PendingPayBook from "./PendingPayBook/PendingPayBook";
import PayBook from "./PayBook/PayBook";

const tabs = [
  {
    name: "Day Book",
    value: "pay-book",
  },
  // {
  //   name: "Pending",
  //   value: "pending",
  // },
  {
    name: "Pending By Manager",
    value: "pending_by_manager",
  },
  {
    name: "Pending By Owner",
    value: "pending_by_owner",
  },
  {
    name: "Approved",
    value: "approved",
  },
];
export default function PayBookLayout() {
  /*   All States
   ********************************************* */
  const [active, setActive] = useState("pay-book");

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  return (
    <div style={{ marginLeft: 260, height: "100vh" }}>
      <div className="pt-2 ms-2">
        <div className="btn-group">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              className={`btn ${
                active === tab.value ? "btn-primary" : "bg-white"
              }`}
              onClick={() => {
                setActive(tab.value);
              }}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="pt-2">
          {active === "pay-book" && (
            <div>
              <PayBook type="none" />
            </div>
          )}
          {active === "pending_by_manager" && (
            <div>
              <PayBook type="pending_by_manager" />
            </div>
          )}
          {active === "pending_by_owner" && (
            <div>
              <PayBook type="pending_by_owner" />
            </div>
          )}
          {active === "approved" && (
            <div>
              <PayBook type="approved" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
